/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaIconSubtract from 'DesignSystem/Svgs/TysiaIconSubtract/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/TreatmentPlans/Content/TreatmentPlan/RemoveAction/Content",
  isSubmitting
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let treatmentPlansIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'treatment_plans',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isSubmitting
  
})
  return (<React.Fragment
>
<button
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 title="Remove"
 {...isHoveredBind}
 onClick={onClick}
 disabled={treatmentPlansIsSubmittingData}
 style={{'--mr-1-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaIconSubtract
  viewPath={`${viewPath}/TysiaIconSubtract`}
/>
</button>
{children}
</React.Fragment>)
}